import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: "I was working 60 hours a week and no matter how much I ran, my belly bloat wouldn't go away. This guide explained WHY. Within 4 days of following the morning reset, the inflammation vanished. I finally feel like myself again.",
  name: 'Sarah J.',
  location: 'Charlotte, NC',
  headline: 'Stress-Belly Win'
}, {
  quote: "I used to wake up at 3 AM every single night with a racing heart. The digital sunset routine in this guide is a game changer. I'm finally sleeping 7+ hours and the mid-day brain fog is totally gone.",
  name: 'Michelle R.',
  location: 'Austin, TX',
  headline: 'Sleep Win'
}, {
  quote: "I've spent hundreds on hormonal supplements that did nothing. This $6 protocol gave me more results in one week than everything else combined. It's simple, realistic for busy moms, and it actually works.",
  name: 'Elena G.',
  location: 'Seattle, WA',
  headline: 'Price/Value Win'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function Testimonials() {
  return <section className="py-24 bg-cream border-t border-cream-dark" data-id="element-136">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-137">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-138">
          <p className="text-xs font-medium text-sage uppercase tracking-[0.2em] mb-4" data-id="element-139">
            Real Results
          </p>
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-140">
            What Women are Saying
          </h2>
          <p className="text-teal-muted text-lg" data-id="element-141">
            Honest words from women who took 7 days to reset their cortisol —
            and got their lives back.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-142">
          {testimonials.map((t, index) => <motion.figure key={index} variants={itemVariants} className="flex flex-col h-full bg-white border border-cream-dark p-8" data-id="element-143">
              <div className="flex items-center mb-6" aria-label="5 out of 5 stars" data-id="element-144">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="w-4 h-4 text-sage fill-sage mr-1" data-id="element-145" />)}
              </div>

              <p className="text-xs font-medium text-sage uppercase tracking-wider mb-4" data-id="element-146">
                The {t.headline}
              </p>

              <blockquote className="font-serif text-lg md:text-xl leading-relaxed text-teal mb-8 flex-grow" data-id="element-147">
                &ldquo;{t.quote}&rdquo;
              </blockquote>

              <figcaption className="border-t border-cream-dark pt-5" data-id="element-148">
                <p className="font-medium text-teal" data-id="element-149">{t.name}</p>
                <p className="text-sm text-teal-muted" data-id="element-150">{t.location}</p>
              </figcaption>
            </motion.figure>)}
        </motion.div>
      </div>
    </section>;
}